import React from 'react';
import SendIcon from '@material-ui/icons/Send';

import {
  Button,
  ButtonProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
} from '@material-ui/core';
import { DialogHeading } from 'components/dialog-title';
import { useTranslate } from 'hooks/use-translate';
import { withRtlRotate } from 'hocs/with-rtl-rotate';

export * from './models';
export * from './components';

const Icon = withRtlRotate(SendIcon);

interface Props {
  title?: string;
  isLoading?: boolean;
  onClose: () => void;
  onSubmit: () => void;
  children?: React.ReactNode;
  DialogProps?: Partial<DialogProps>;
  ButtonSendProps?: Partial<ButtonProps>;
}

export const DialogSendMessage = ({
  title,
  isLoading = false,
  onClose,
  onSubmit,
  children,
  DialogProps,
  ButtonSendProps,
}: Props) => {
  const { t } = useTranslate();

  return (
    <Dialog fullWidth={true} maxWidth={'lg'} open={true} onClose={onClose} {...DialogProps}>
      <DialogHeading
        isLoading={isLoading}
        title={title || t('dialog-send-message')}
        onClose={onClose}
      />
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button color={'secondary'} onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button
          color={'primary'}
          variant={'contained'}
          endIcon={<Icon />}
          {...ButtonSendProps}
          onClick={onSubmit}
          disabled={isLoading || ButtonSendProps?.disabled}
        >
          {t('send')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
